<ng-container *ngIf="!bankTransferLoad.isMarkedForRefund && !bankTransferLoad.isRefunded">
  <div *ngIf="bankTransferLoad.isApprovedAutomatically && !bankTransferLoad.isApprovedManually && !bankTransferLoad.isDeclinedManually">
    <mat-icon style="color: dodgerblue">done</mat-icon> Approved automatically
  </div>
  <div *ngIf="bankTransferLoad.isApprovedManually">
    <mat-icon style="color: forestgreen">done</mat-icon> Approved manually
  </div>
  <div *ngIf="bankTransferLoad.isDeclinedManually">
    <mat-icon style="color: red;">clear</mat-icon> Declined manually
  </div>
  <div *ngIf="bankTransferLoad.needsManualApproval && !bankTransferLoad.isApprovedManually && !bankTransferLoad.isApprovedAutomatically && !bankTransferLoad.isDeclinedManually && !bankTransferLoad.isPreApprovedManually">
    ⚠️ Needs manual approval
  </div>
  <div *ngIf="bankTransferLoad.needsManualApproval && !bankTransferLoad.isApprovedManually && !bankTransferLoad.isApprovedAutomatically && !bankTransferLoad.isDeclinedManually && bankTransferLoad.isPreApprovedManually">
    ⚠️ Needs second approval
  </div>
</ng-container>

<div *ngIf="bankTransferLoad.isMarkedForRefund && !bankTransferLoad.isRefunded">
  <mat-icon style="color: #ff7b4d">money_off</mat-icon> To be refunded
</div>

<div *ngIf="bankTransferLoad.isRefunded">
  <mat-icon style="color: #6b6b6b">money_off</mat-icon> Refunded
</div>

<ng-container *ngIf="customer && bankTransferLoad && bankTransferLoad.isDocsRequested">
  <div *ngIf="!bankTransferLoad.isDocsApproved ">
    ⚠️ <a [routerLink]="'/idv-customers-overview/' + customer.id">Waiting for Documentation decision</a>
  </div>
  <div *ngIf="bankTransferLoad.isDocsApproved ">
    <mat-icon style="color: forestgreen">done</mat-icon> Documentation approved
  </div>
</ng-container>


<div *ngIf="bankTransferLoad.webIdTransactionId && bankTransferLoad.webIdTransaction.status === webIdTransactionStatus.pending">
  ⚠️ Waiting for Ident
</div>
<div *ngIf="bankTransferLoad.webIdTransactionId && bankTransferLoad.webIdTransaction.status === webIdTransactionStatus.fail">
  ⚠️ Ident failed
</div>
<div *ngIf="bankTransferLoad.webIdTransactionId && bankTransferLoad.webIdTransaction.status === webIdTransactionStatus.success">
  <mat-icon style="color: forestgreen">done</mat-icon> Web ID success
</div>

<div *ngIf="bankTransferLoad.isPreApprovedManually && bankTransferLoad.preApprovedManuallyByUserName">
  <mat-icon style="color: purple">group_work</mat-icon> Pre-Approval by {{ bankTransferLoad.preApprovedManuallyByUserName }}
</div>
<div *ngIf="bankTransferLoad.isApprovedManually && bankTransferLoad.approvedManuallyByUserName">
  <mat-icon style="color: forestgreen">thumb_up</mat-icon> Approved manually by {{ bankTransferLoad.approvedManuallyByUserName }}
</div>
<div *ngIf="bankTransferLoad.isExported && bankTransferLoad.exportedByUserName">
  <mat-icon style="color: dodgerblue">credit_card</mat-icon> Executed by {{ bankTransferLoad.exportedByUserName }}
</div>
<div *ngIf="bankTransferLoad.isDeclinedManually && bankTransferLoad.declinedManuallyByUserName">
  <mat-icon style="color: red">clear</mat-icon> Declined manually by {{ bankTransferLoad.declinedManuallyByUserName }}
</div>

